/* src/app/components/appointment/appointment.component.css */
.collapsible {
  position: relative;
}
.collapsible::after {
  content: "";
  position: absolute;
  top: 25px;
  bottom: 25px;
  left: 25px;
  border-left: 1px solid #ddd;
}
.collapsible .collapsible-header {
  border: none;
}
.collapsible .collapsible-body {
  background: #fff;
  padding-left: 50px;
  border: none;
}
.suffix {
  position: absolute;
  right: 5px;
}
i.small {
  font-size: 1rem;
}
i.redo {
  padding: 0 10px 5px 0;
}
.not-editable {
  pointer-events: none;
  cursor: default;
}
.bubble {
  background: #26a69a;
  color: #fff;
  padding: 10px;
  margin-right: 12px;
  display: block;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  flex-shrink: 0;
  position: relative;
  z-index: 5;
}
.bubble > * {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}
.actions {
  margin-top: 18px;
  min-height: 36px;
}
/*# sourceMappingURL=appointment.component.css.map */
